import React, { useEffect } from 'react';
import { parseApiDate } from '../utils/security';
import TsKayitDavetLinkCard from './TsKayitDavetLinkCard';
import './BayilikBasvuruDetayModal.css';

const DURUM_LABELS = {
  onay_bekliyor: 'Onay Bekliyor',
  onaylandi: 'Onaylandı',
  reddedildi: 'Reddedildi',
};

const DURUM_BADGE = {
  onay_bekliyor: { bg: '#fef3c7', color: '#92400e' },
  onaylandi: { bg: '#d1fae5', color: '#065f46' },
  reddedildi: { bg: '#fee2e2', color: '#991b1b' },
};

const DAVET_DURUM_LABELS = {
  aktif: 'Aktif',
  suresi_doldu: 'Süresi doldu',
  pasif: 'Pasif',
};

const formatTarih = (val) => {
  const d = parseApiDate(val);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });
};

function DurumBadge({ durum }) {
  const style = DURUM_BADGE[durum] || { bg: '#f1f5f9', color: '#334155' };
  return (
    <span className="bbd-header-badge" style={{ backgroundColor: style.bg, color: style.color }}>
      {DURUM_LABELS[durum] || durum}
    </span>
  );
}

const Field = ({ label, children, full }) => (
  <div className={`bbd-field ${full ? 'bbd-field-full' : ''}`}>
    <span className="bbd-field-label">{label}</span>
    <div className="bbd-field-value">{children}</div>
  </div>
);

const TsKayitBasvuruDetayModal = ({
  detail,
  davetDetail,
  loading,
  error,
  onClose,
  onOnayla,
  onReddet,
  redNedeni,
  onRedNedeniChange,
  actionLoading = false,
  pasifLoading = false,
  onPasifAl,
  onGecerlilikDuzenle,
  mode = 'basvuru',
}) => {
  const isDavet = mode === 'davet';
  const canOnayRed = !isDavet && detail?.durum === 'onay_bekliyor';
  const canPasifAl = isDavet && davetDetail?.durum === 'aktif';
  const canGecerlilikDuzenle = isDavet && davetDetail?.durum !== 'pasif';
  const footerBusy = actionLoading || pasifLoading;

  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape' && !footerBusy) onClose?.();
    };
    document.addEventListener('keydown', handleEsc);
    return () => document.removeEventListener('keydown', handleEsc);
  }, [onClose, footerBusy]);

  const baslik = isDavet
    ? 'Davet Linki'
    : (detail?.techService?.ad || 'Servis Başvurusu');

  return (
    <div className="modal-overlay bayilik-basvuru-detay-modal" onClick={onClose} role="presentation">
      <div className="modal-content" onClick={(e) => e.stopPropagation()} role="dialog" aria-modal="true">
        <div className="modal-header">
          <h2>
            <i className={`fas ${isDavet ? 'fa-link' : 'fa-tools'}`} />
            {baslik}
            {!isDavet && detail?.durum ? <DurumBadge durum={detail.durum} /> : null}
          </h2>
          <button type="button" className="modal-close-btn" onClick={onClose} aria-label="Kapat">
            <i className="fas fa-times" />
          </button>
        </div>

        <div className="modal-body">
          {loading && (
            <div className="loading-state">
              <div className="loading-spinner" />
              <div className="loading-text">Detay yükleniyor</div>
            </div>
          )}

          {!loading && error && <div className="error-state">{error}</div>}

          {!loading && !error && isDavet && davetDetail && (
            <div className="bbd-content">
              <TsKayitDavetLinkCard url={davetDetail.url} compact />
              <section className="bbd-section">
                <div className="bbd-section-title">
                  <i className="fas fa-link" />
                  Link Bilgileri
                </div>
                <div className="bbd-grid">
                  <Field label="Durum">{DAVET_DURUM_LABELS[davetDetail.durum] || davetDetail.durum}</Field>
                  <Field label="Geçerlilik">{formatTarih(davetDetail.gecerlilikBitis)}</Field>
                  <Field label="Oluşturma">{formatTarih(davetDetail.createdAt)}</Field>
                  {davetDetail.olusturanKullanici && (
                    <Field label="Oluşturan">{davetDetail.olusturanKullanici.kullaniciAdi}</Field>
                  )}
                </div>
              </section>
            </div>
          )}

          {!loading && !error && !isDavet && detail && (
            <div className="bbd-content">
              <section className="bbd-section">
                <div className="bbd-section-title">
                  <i className="fas fa-user" />
                  Başvuru
                </div>
                <div className="bbd-grid">
                  <Field label="Kullanıcı adı">{detail.kullaniciAdi}</Field>
                  <Field label="Teknik servis">{detail.techService?.ad || '—'}</Field>
                  {detail.techService?.kod != null && (
                    <Field label="Kod">#{detail.techService.kod}</Field>
                  )}
                  {detail.techService?.ilAdi && (
                    <Field label="İl">{detail.techService.ilAdi}</Field>
                  )}
                  <Field label="Başvuru tarihi">{formatTarih(detail.createdAt)}</Field>
                  {detail.durum === 'reddedildi' && detail.redNedeni && (
                    <Field label="Red nedeni" full>{detail.redNedeni}</Field>
                  )}
                </div>
              </section>
            </div>
          )}

          {canOnayRed && (
            <div className="bbd-red-neden">
              <label htmlFor="ts-red-nedeni">Red nedeni</label>
              <textarea
                id="ts-red-nedeni"
                rows={3}
                value={redNedeni}
                onChange={(e) => onRedNedeniChange?.(e.target.value)}
                placeholder="Reddetmek için zorunlu"
              />
            </div>
          )}
        </div>

        <div className="modal-footer">
          <button type="button" className="secondary-btn" onClick={onClose} disabled={footerBusy}>
            Kapat
          </button>
          {canPasifAl && (
            <button
              type="button"
              className="danger-btn"
              onClick={onPasifAl}
              disabled={footerBusy}
            >
              {pasifLoading ? 'Pasife alınıyor...' : 'Pasife al'}
            </button>
          )}
          {canGecerlilikDuzenle && (
            <button
              type="button"
              className="primary-btn"
              onClick={onGecerlilikDuzenle}
              disabled={footerBusy}
            >
              Geçerlilik düzenle
            </button>
          )}
          {canOnayRed && (
            <>
              <button
                type="button"
                className="danger-btn"
                onClick={onReddet}
                disabled={footerBusy}
              >
                Reddet
              </button>
              <button
                type="button"
                className="primary-btn"
                onClick={onOnayla}
                disabled={footerBusy}
              >
                {actionLoading ? 'Onaylanıyor...' : 'Onayla'}
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default TsKayitBasvuruDetayModal;
